import React from 'react'

const SpeedButton = ({ speed, playbackRate, changeSpeed }) => {
  return (
    <button
      onClick={() => changeSpeed(speed)}
      className={`plyr-btn obro-btn obro-light-gray-btn ${playbackRate === speed ? 'active' : ''}`}
    >
      {speed}x
    </button>
  )
}

export default SpeedButton
